import React, {useState, useEffect} from 'react';
import MUIDataTable from "mui-datatables";
import { useSelector} from "react-redux";
import { language } from 'config';
import {
    Grid,
    Typography
} from '@material-ui/core';
import DashboardCard from '../components/DashboardCard';
import CircularLoading from "../components/CircularLoading";


export default function Earningreports() {

  const [dailygross,setDailygross] = useState(0);
  const [monthlygross,setMonthlygross] = useState(0);
  const [totalgross,setTotalgross] = useState(0);
  const [settings,setSettings] = useState({});
  const usersdata = useSelector(state => state.usersdata);
  const bookinglistdata = useSelector(state => state.bookinglistdata);
  const settingsdata = useSelector(state => state.settingsdata);
  //const auth = useSelector(state => state.auth);

  useEffect(()=>{
      if(settingsdata.settings){
        setSettings(settingsdata.settings);
      }
  },[settingsdata.settings]);

  useEffect(()=>{
      if(bookinglistdata.bookings){
          let today =  new Date();
          let convenniencefees = 0;
          let totconvenienceTrans = 0;
          let todayConvenience = 0;
          for(let i=0;i<bookinglistdata.bookings.length;i++){
              if(bookinglistdata.bookings[i].status === 'PAID' || bookinglistdata.bookings[i].status === 'COMPLETE'){
                  const {tripdate,convenience_fees} = bookinglistdata.bookings[i];
                  let tDate = new Date(tripdate);
                  if(convenience_fees>0){

                      if(tDate.getMonth() === today.getMonth() && tDate.getFullYear() === today.getFullYear()){
                          convenniencefees = convenniencefees + parseFloat(convenience_fees);
                      }
                      if(tDate.getDate() === today.getDate() && tDate.getMonth() === today.getMonth()){
                          todayConvenience  = todayConvenience + parseFloat(convenience_fees);
                      } 
                      totconvenienceTrans  = totconvenienceTrans + parseFloat(convenience_fees);
                  }
              }
          }
          setDailygross(parseFloat(todayConvenience).toFixed(2));
          setMonthlygross(parseFloat(convenniencefees).toFixed(2));
          setTotalgross(parseFloat(totconvenienceTrans).toFixed(2));
      }
  },[bookinglistdata.bookings]);

  const columns = [
    {
     name: "monthsName",
     label: language.months,
     field: 'monthsName',
     options: {
      filter: true,
      sort: true,
     }
    },
    {
    name: "year",
     label: language.year,
     field: 'year',
     options: {
      filter: true,
      sort: true,
     }
    },
    {
      name: "tripCost",
       label: language.Gross_trip_cost,
       field: 'tripCost',
       options: {
        sort: true,
        filter: false,
       }
      },
      {
        name: "rideCost",
         label: language.trip_cost_driver_share,
         field: 'rideCost',
         options: {
          sort: true,
          filter: false,
         }
        },
          {
            name: "convenience_fee",
             label: language.convenience_fee,
             field: 'convenience_fee',
             options: {
              sort: true,
              filter: false,
             }
            },
            {
              name: "discountAmount",
               label: language.Discounts,
               field: 'discountAmount',
               options: {
                sort: true,
                filter: false,
               }
              },
              {
              name: 'grandTotal',
              label: language.Profit,
              field: 'grandTotal',
              // field: {
              //   render: rowData => (parseFloat(rowData.convenienceFee) - parseFloat(rowData.discountAmount)).toFixed(2)
              // },
              options: {
               sort: true,
               filter: false,
              }
             },

   ];
     const [data, setData] = useState([]);
  const earningreportsdata = useSelector(state => state.earningreportsdata);

  useEffect(()=>{
        if(earningreportsdata.Earningreportss){
            setData(earningreportsdata.Earningreportss);
        }
  },[earningreportsdata.Earningreportss]);
   
   const options = {
     filterType: 'checkbox',
     selectableRows: false,
   };

  return (
      bookinglistdata.loading || usersdata.loading ? <CircularLoading/> :
      <>
      <div>
          <Typography variant="h6" style={{margin:"0px 0 5px 1px"}}>{language.gross_earning}</Typography>
          <Grid container direction="row" spacing={2}>
              <Grid item xs>
                  <DashboardCard title={language.today_text} image={require("../assets/img/money1.jpg").default}>{ settings.symbol + ' ' + dailygross}</DashboardCard>
              </Grid>
              <Grid item xs>
                  <DashboardCard title={language.this_month_text} image={require("../assets/img/money2.jpg").default}>{ settings.symbol +' ' +  monthlygross}</DashboardCard>
              </Grid>
              <Grid item xs>
                  <DashboardCard title={language.total} image={require("../assets/img/money3.jpg").default}>{ settings.symbol +' ' +  totalgross}</DashboardCard>
              </Grid>
          </Grid>

      </div>
      <br></br>
      <div>
      
<MUIDataTable
  title={language.earning_reports}
  data={data}
  columns={columns}
  options={options}
/>
</div>
</>
);
}

